import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _class2, _nextBlockBlinkingTimer, _blockBlinkingTimer, _blockShownTimer, _AiSummarySkeleton_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './ai-summary-skeleton.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { cancel } from "@ember/runloop";
import discourseLater from "discourse-common/lib/later";
import TEMPLATE from "./ai-summary-skeleton.hbs";
import { setComponentTemplate } from "@ember/component";
let Block = (_class = class Block {
  constructor() {
    let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _initializerDefineProperty(this, "show", _descriptor, this);
    _initializerDefineProperty(this, "shown", _descriptor2, this);
    _initializerDefineProperty(this, "blinking", _descriptor3, this);
    this.show = args.show ?? false;
    this.shown = args.shown ?? false;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "show", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "shown", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "blinking", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class);
const BLOCKS_SIZE = 20; // changing this requires to change css accordingly
let AiSummarySkeleton = (_class2 = (_nextBlockBlinkingTimer = /*#__PURE__*/new WeakMap(), _blockBlinkingTimer = /*#__PURE__*/new WeakMap(), _blockShownTimer = /*#__PURE__*/new WeakMap(), _AiSummarySkeleton_brand = /*#__PURE__*/new WeakSet(), class AiSummarySkeleton extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _AiSummarySkeleton_brand);
    _defineProperty(this, "blocks", [...Array.from({
      length: BLOCKS_SIZE
    }, () => new Block())]);
    _classPrivateFieldInitSpec(this, _nextBlockBlinkingTimer, void 0);
    _classPrivateFieldInitSpec(this, _blockBlinkingTimer, void 0);
    _classPrivateFieldInitSpec(this, _blockShownTimer, void 0);
  }
  setupAnimation() {
    this.blocks.firstObject.show = true;
    this.blocks.firstObject.shown = true;
  }
  onBlinking(block) {
    if (!block.blinking) {
      return;
    }
    block.show = false;
    _classPrivateFieldSet(_nextBlockBlinkingTimer, this, discourseLater(this, () => {
      _assertClassBrand(_AiSummarySkeleton_brand, this, _nextBlock).call(this, block).blinking = true;
    }, 250));
    _classPrivateFieldSet(_blockBlinkingTimer, this, discourseLater(this, () => {
      block.blinking = false;
    }, 500));
  }
  onShowing(block) {
    if (!block.show) {
      return;
    }
    _classPrivateFieldSet(_blockShownTimer, this, discourseLater(this, () => {
      _assertClassBrand(_AiSummarySkeleton_brand, this, _nextBlock).call(this, block).show = true;
      _assertClassBrand(_AiSummarySkeleton_brand, this, _nextBlock).call(this, block).shown = true;
      if (this.blocks.lastObject === block) {
        this.blocks.firstObject.blinking = true;
      }
    }, 250));
  }
  teardownAnimation() {
    cancel(_classPrivateFieldGet(_blockShownTimer, this));
    cancel(_classPrivateFieldGet(_nextBlockBlinkingTimer, this));
    cancel(_classPrivateFieldGet(_blockBlinkingTimer, this));
  }
}), (_applyDecoratedDescriptor(_class2.prototype, "setupAnimation", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setupAnimation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onBlinking", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onBlinking"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onShowing", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onShowing"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "teardownAnimation", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "teardownAnimation"), _class2.prototype)), _class2);
function _nextBlock(currentBlock) {
  if (currentBlock === this.blocks.lastObject) {
    return this.blocks.firstObject;
  } else {
    return this.blocks.objectAt(this.blocks.indexOf(currentBlock) + 1);
  }
}
export { AiSummarySkeleton as default };
setComponentTemplate(TEMPLATE, AiSummarySkeleton);